module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-200.edbce16a90aa22c297a0307b85789837.woff";